import type { i18n } from 'i18next'
import { getKeyFallback } from 'utils/i18nUtils'

const getPackageLabels = ({
  value,
  name,
  i18n,
}: {
  value: string
  name?: string
  i18n: i18n
}) => {
  const title = getKeyFallback(
    i18n,
    `packages:${value}.title`,
    `packages:${name ?? value}.title`
  )
  const desc = getKeyFallback(
    i18n,
    `packages:${value}.desc`,
    `packages:${name ?? value}.desc`
  )

  return { title, desc }
}

export default getPackageLabels
